import { render, staticRenderFns } from "./LastMotivationsWidget.vue?vue&type=template&id=6294aadf&"
import script from "./LastMotivationsWidget.vue?vue&type=script&lang=js&"
export * from "./LastMotivationsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports